import { render, staticRenderFns } from "./Newsmanage.vue?vue&type=template&id=b0674282&scoped=true&"
import script from "./Newsmanage.vue?vue&type=script&lang=js&"
export * from "./Newsmanage.vue?vue&type=script&lang=js&"
import style0 from "./Newsmanage.vue?vue&type=style&index=0&id=b0674282&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0674282",
  null
  
)

export default component.exports